/*
 * @Author: your name
 * @Date: 2022-03-25 18:18:43
 * @LastEditTime: 2024-05-09 16:29:29
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /visaai-platform/src/data/baseURL.js
 */

export const baseURLs = {
  api: {
    prod: 'https://visasapi.visaai.com/',
    'prod-file': 'https://file.visaai.com/', // 正式环境文件服务器地址，文件相关接口使用这个地址
    pre: 'http://visasapi.pre.visaai.com/',
    test: 'http://visas-api.int.anniu-tech.com/',
    'test-file': 'http://visas-api.int.anniu-tech.com/', // 测试环境文件服务器地址，文件相关接口使用这个地址
    newTest: 'http://visas-api.qa.visaapp6.com/',
    'newTest-file': 'http://visas-api.qa.visaapp6.com/', // 测试环境文件服务器地址，文件相关接口使用这个地址
    localydw: 'http://192.168.1.141:8096/',
    localwm: 'http://192.168.1.9:8096/',
    localzcl: 'http://192.168.1.114:8096/',
  
    // converted_url = 'http://192.168.1.141:8099/' + url
    'localydw-file': 'http://172.100.15.118:8096/',
    newOnline: 'http://192.168.5.5:8098/',
    localhost:'http://127.0.0.1:8096/'
  },
  //飞猪
  ota: {
    prod: 'https://visasotaapi.thunderrpa.com/',
    pre: 'https://visasotaapi.visaai.com/',
    test: 'http://visas-ota-api.int.anniu-tech.com/',
    newTest: 'http://192.168.5.5:9091/',
    localydw: 'http://172.18.8.236:8091/',
  },
  soa: {
    prod: 'https://order-api.visaai.com/',
    pre: 'http://order-api.pre.visaai.com/',
    test: 'http://visas-order-soa.int.anniu-inc.com/',
    newTest: 'http://192.168.5.5:8087/',
    localydw: 'http://172.18.8.236:8096/',
    localypp: 'http://172.18.8.24:8096/',
  },
  desk: {
    prod: 'https://service-desk.thunderrpa.cn/',
    test: 'https://visas-service-desk.int.anniu-tech.com/',
    newTest: 'http://192.168.5.5:8081/',
    localydw: 'http://172.18.8.236:8096/',
    localypp: 'http://172.18.8.24:8096/',
  }
}